var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.update_exists)?_c('b-col',{attrs:{"cols":"12","xl":"11"}},[_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.refreshApp}},[_vm._v(" Nueva version disponible, click para actualizar ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }